import {useQuery} from "@tanstack/vue-query";
import axios from "axios";
import {computed, ref} from "vue";

const orderBy = ref('name');
const search = ref('');
const orderDirection = ref('asc');
const visibleRows = ref(50);

export const useTemplateFilters = () => {
  const changeOrderBy = (name) => {
    if (orderBy.value === name) {
      orderDirection.value = orderDirection.value === 'asc' ? 'desc' : 'asc';
      return;
    }
    orderBy.value = name;
    orderDirection.value = 'desc';
  };

  return {
    search,
    orderBy,
    orderDirection,
    changeOrderBy,
  };
};

export const useTemplates = (url = '/ajax/v2/mail/templates') => {
  const query = useQuery({
    queryKey: ['email-templates'],
    queryFn: async () => {
      const {data} = await axios.get(url);

      return data.data;
    },
  });

  const templates = computed(() =>
    [...query.data.value ?? []]
      .filter(template => template.name.toLowerCase().includes(search.value.toLowerCase()))
      .sort(function (a, b) {
        if (orderDirection.value === 'asc') {
          return a[orderBy.value] > b[orderBy.value] ? 1 : -1;
        }

        return a[orderBy.value] < b[orderBy.value] ? 1 : -1;
      })
      .slice(0, visibleRows.value)
  );

  return {
    query,
    templates,
    visibleRows,
  };
};

const templateId = ref(null);
const isAdminView = ref(false);

const editableContent = ref({
  body: '',
  subject: '',
  from_email: ''
});

const getTemplateContent = () => useQuery({
    queryKey: ['email-template-contents', {templateId, isAdminView}],
    queryFn: async () => {
      const endpoint = isAdminView.value
        ? `/ajax/v2/admin/mail/template/${templateId.value}/content`
        : `/ajax/v2/mail/template/${templateId.value}/content`;

      const {data} = await axios.get(endpoint);

      if (data.data) {
        editableContent.value = {
          body: data.data.email_content?.body || '',
          subject: data.data.email_content?.subject || '',
          from_email: data.data.whitelabel_branding?.custom_email?.from_email || ''
        };
      }


      return data.data;
    },
    enabled: () => !!templateId.value,
  });

export {
  getTemplateContent,
  templateId,
  editableContent,
  isAdminView,
};
